import { alSelClass } from '../../utils/alSelClass';

export type IdFieldSelectOption = {
  id: string;
  label: string;
};

export type IdFieldSelectProps = {
  id?: string;
  fieldKey?: string;
  label: string;
  required?: boolean;
  value: string;
  placeholder?: string;
  options: IdFieldSelectOption[];
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  emptyMessage?: string;
};

/** Native `<select class="al-sel">` for UUID-backed options — matches Intranet User form dropdowns. */
export function IdFieldSelect({
  id,
  fieldKey,
  label,
  required,
  value,
  placeholder,
  options,
  onChange,
  error,
  disabled = false,
  emptyMessage = 'No data found',
}: IdFieldSelectProps) {
  const selectDisabled = disabled || options.length === 0;
  const errId = error ? `${id ?? fieldKey ?? label}-err` : undefined;

  return (
    <div className="al-f">
      <div className="al-l">
        {label} {required ? <span className="req">*</span> : null}
      </div>
      <select
        id={id}
        className={alSelClass(value)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={selectDisabled}
        style={error ? { borderColor: 'var(--red)' } : undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={errId}
      >
        {options.length === 0 ? (
          <option value="" disabled>
            {emptyMessage}
          </option>
        ) : (
          <>
            {placeholder ? (
              <option value="" disabled hidden>
                {placeholder}
              </option>
            ) : null}
            {options.map((o) => (
              <option key={o.id} value={o.id}>
                {o.label}
              </option>
            ))}
          </>
        )}
      </select>
      {error ? (
        <div id={errId} style={{ fontSize: 11, color: 'var(--red)', marginTop: 6, fontWeight: 600 }}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
